import { useState, Dispatch, SetStateAction } from "react";
import { LifecycleManagementAllEvents } from "@lib/ShiOneClient";
import {
  ActivityFilterPanel,
  createDefaultActivityFilters,
  type ActivityFilterState,
} from "shared-ui";
import AssetLifecycleManagementDrawerActivityDetails from "./AssetLifecycleManagementDrawerActivityDetails";
import { useLifecycleActivityApi } from "./hooks/useLifecycleActivityApi";

interface AssetLifecycleManagementDrawerActivityProps {
  selectedLifecycleEventData: LifecycleManagementAllEvents | undefined;
  setSelectedLifecycleEventData?: Dispatch<
    SetStateAction<LifecycleManagementAllEvents | undefined>
  >;
}

export default function AssetLifecycleManagementDrawerActivity({
  selectedLifecycleEventData,
  setSelectedLifecycleEventData,
}: Readonly<AssetLifecycleManagementDrawerActivityProps>) {
  const [filters, setFilters] = useState<ActivityFilterState>(
    createDefaultActivityFilters,
  );

  const {
    isLoading: isLoadingActivity,
    actors,
    changedKeys,
  } = useLifecycleActivityApi(
    selectedLifecycleEventData,
    filters.dateFrom,
    filters.dateTo,
  );

  return (
    <ActivityFilterPanel
      filters={filters}
      onFiltersChange={setFilters}
      actors={actors}
      changedKeys={changedKeys}
      isLoading={isLoadingActivity}
      resetKey={selectedLifecycleEventData?.id}
      formatEventLabel={(key) => `${key} change`}
    >
      <AssetLifecycleManagementDrawerActivityDetails
        selectedLifecycleEventData={selectedLifecycleEventData}
        dateFrom={filters.dateFrom}
        dateTo={filters.dateTo}
        userFilter={filters.userFilter}
        eventFilter={filters.eventFilter}
        setSelectedLifecycleEventData={setSelectedLifecycleEventData}
      />
    </ActivityFilterPanel>
  );
}
